import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["children", "skin", "className", "onClick", "size", "light"];
import React from 'react';
import { Box, Text } from '@wix/design-system';
export const StringElement = _ref => {
  let children = _ref.children,
    skin = _ref.skin,
    className = _ref.className,
    onClick = _ref.onClick,
    size = _ref.size,
    light = _ref.light,
    boxProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Text, {
    className: className,
    skin: skin,
    onClick: onClick,
    size: size,
    light: light
  }, /*#__PURE__*/React.createElement(Box, _extends({
    display: "inline-block",
    alignSelf: "center"
  }, boxProps), children));
};
//# sourceMappingURL=StringElement.js.map